module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc34-68868cb3c51abb9ef9c8c97bf6a16353.jpg";